import React from "react";
import { Card, Container, Icon, Rail, Subtitle, TextCol, Title } from "./Styles";

export interface ListingCarouselCard {
  icon?: string;
  title?: string;
  subtitle?: string;
}

interface ListingCarouselPersuasionProps {
  cards?: ListingCarouselCard[];
}

export const ListingCarouselPersuasion = ({
  cards,
}: ListingCarouselPersuasionProps) => {
  if (!cards?.length) return null;

  return (
    <Container>
      <Rail>
        {cards.map((item, idx) => (
          <Card key={`${item.title}-${idx}`}>
            {item.icon ? <Icon src={item.icon} alt="" /> : null}
            <TextCol>
              <Title>{item.title}</Title>
              <Subtitle>{item.subtitle}</Subtitle>
            </TextCol>
          </Card>
        ))}
      </Rail>
    </Container>
  );
};
